<div class="map-catalog">
    <div class="folders">
        <kendo-tabstrip *ngIf="loggedIn">
            <kendo-tabstrip-tab *ngIf="showSystemMaps" [title]="'System Maps'"
                                [selected]="showSystemMaps ? true : false">
                <ng-template kendoTabContent>
                    <ng-container *ngIf="systemMaps && systemMaps.length > 0 && !systemMapErrorMessage">

                        <div class="form-group" [formGroup]="searchInputForm">
                            <div class="filter-box" style="overflow: hidden;">
                                <div class="input-container">
                                    <input class="input-group-input form-control" type="text" formControlName="searchInput"
                                           placeholder="Filter by map name." [(ngModel)]="searchText" />
                                </div>
                                <div class="icon-container">
                                    <i class="icon-ui-filter"></i>
                                </div>
                            </div>
                        </div>

                        <div class="canvas">
                            <ul class="list-plain map-list">
                                <li class="clearfix"
                                    *ngFor="let map of systemMaps | mcDataFilter:[searchTerm, filteredResultCount] | mcDataPaginate:{ current: current, limit: limit}">

                                    <mc-map-catalog-item-ng [map]="map" [mergeMaps]="mergeMaps" [mapItemType]="'System'"
                                                            (closeWindowEvent)="closeWindow($event)" (mapOpened)="mapOpened($event)" (openMergeMap)="mapMerged($event)">
                                    </mc-map-catalog-item-ng>

                                </li>
                            </ul>
                        </div>

                        <div class="pull-left text-center trailer-1 leader-1" *ngIf="pageSize > 1">
                            <a class="btn btn-transparent" [ngClass]="current == 0? 'btn-disabled': ''"
                               (click)="!!previous()">Previous</a>
                            <a *ngFor="let p of pageSizeArray; let i = index" class="btn"
                               [ngClass]="current !== i ? 'btn-transparent': ''" (click)="!!go(i)">
                                {{ i+1 }}
                            </a>

                            <a class="btn btn-transparent btn-arrow" [ngClass]="current == pageSize - 1? 'btn-disabled': ''"
                               (click)="!!next()">Next</a>

                        </div>


                    </ng-container>
                    <ng-container *ngIf="systemMapErrorMessage">
                        <div>
                            {{ systemMapErrorMessage }}
                        </div>
                    </ng-container>
                    <div *ngIf="systemLoading.status">
                        <div class="loader is-active padding-leader-3 padding-trailer-3">
                            <div class="loader-bars"></div>
                            <div class="loader-text">{{ systemLoading.text }}</div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'My Maps'" *ngIf="userId && showUserMaps" [selected]="showSystemMaps ? false : true">
                <ng-template kendoTabContent>
                    <div *ngIf="userMapNodes && !userMapErrorMessage" [hidden]="showFolderEditor || showFolderPicker" class="user-maps-container">
                        <div class="form-group" [formGroup]="searchInputForm">
                            <div class="input-group filter-box">
                                <div class="input-container">
                                    <input class="input-group-input form-control" type="text" formControlName="searchInput"
                                           placeholder="Filter by map name." [(ngModel)]="searchText" />
                                </div>
                                <div class="icon-container">
                                    <i class="icon-ui-filter"></i>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix new-folder">
                            <div class="pull-left">
                                <button class="btn btn-green" (click)="addFolder()">
                                    <span class="icon-ui-plus"></span>&nbsp;New
                                    Folder
                                </button>
                            </div>
                            <div class="pull-right" style="padding-top: 6px;">
                                Sort By:
                                <label class="toggle-switch" style="display: inline-block; margin: 0;">
                                    <span class="toggle-switch-label" style="padding-right: 5px;">Name</span>
                                    <input type="checkbox" class="toggle-switch-input" [(ngModel)]="userMapSortByEdited" (change)="loadFilteredUserMaps()">
                                    <span class="toggle-switch-track"></span>
                                    <span class="toggle-switch-label" style="padding-left: 5px;">Last Edited</span>
                                </label>
                            </div>
                        </div>

                        <div class="user-maps-list">
                            <tree-root *ngIf="!loading.status" #userMapTree [nodes]="userMapNodes" [options]="treeOptions" class="map-list">

                                <ng-template #treeNodeTemplate let-node let-index="index">

                                    <ng-container *ngIf="node.hasChildren || node.data.nodeType == 'group'">
                                        <span class="group-title">{{ node.data.name }}</span>
                                        <div class="pull-right folder-buttons">
                                            <button title="Edit Folder" [disabled]="multiSelectEnabled" type="button" class="btn  btn-clear btn-small"
                                                    (click)="editFolder(node.data)">
                                                <span class="icon-ui-edit" aria-hidden="true"></span>
                                            </button>
                                            <button title="Add Sub-Folder" [disabled]="multiSelectEnabled" type="button" class="btn btn-green btn-small"
                                                    (click)="addFolder(node.data)">
                                                <span class="icon-ui-plus" aria-hidden="true"></span>
                                            </button>
                                            <button title="Delete Folder" [disabled]="multiSelectEnabled" type="button" class="btn btn-red btn-small"
                                                    (click)="deleteFolder(node.data)">
                                                <span class="icon-ui-close-circled" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="node.isLeaf">
                                        <mc-map-catalog-item-ng [map]="node.data.map" [mergeMaps]="mergeMaps" [owner]="node.data.owner"
                                                                [mapItemType]="'User'" [multiSelectEnabled]="multiSelectEnabled"
                                                                (closeWindowEvent)="closeWindow($event)"
                                                                (changeFolderEvent)="pickFolder($event)" (deleteMapEvent)="deleteMap($event)"
                                                                (openMergeMap)="mapMerged($event)">
                                        </mc-map-catalog-item-ng>
                                    </ng-container>
                                </ng-template>
                            </tree-root>
                        </div>

                        <div *ngIf="userMapErrorMessage">
                            {{ userMapErrorMessage }}
                        </div>
                        <div *ngIf="loading.status">
                            <div class="loader is-active padding-leader-3 padding-trailer-3">
                                <div class="loader-bars"></div>
                                <div class="loader-text">{{ loading.text }}</div>
                            </div>
                        </div>

                        <div class="multi-select clearfix">
                            <div class="pull-left">
                                <button *ngIf="!multiSelectEnabled" class="btn btn-green" (click)="toggleMultiSelect()">
                                    <span class="icon-ui-table"></span>&nbsp;Open Multi-Select
                                </button>

                                <button *ngIf="multiSelectEnabled" class="btn btn-green" (click)="toggleMultiSelect()">
                                    <span class="icon-ui-table"></span>&nbsp;Close Multi-Select
                                </button>
                                <button *ngIf="multiSelectEnabled" [disabled]="!mapsSelected.length" class="btn btn-green" (click)="shareMulti()">
                                    <span class="icon-ui-share" aria-hidden="true"></span>&nbsp;Share
                                </button>
                                <button *ngIf="multiSelectEnabled" [disabled]="!mapsSelected.length" class="btn btn-green" (click)="unshareMulti()">
                                    <span class="icon-ui-user" aria-hidden="true"></span>&nbsp;Unshare
                                </button>
                                <button *ngIf="multiSelectEnabled" [disabled]="!mapsSelected.length" class="btn btn-green" (click)="deleteMulti()">
                                    <span class="icon-ui-trash" aria-hidden="true"></span>&nbsp;Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="folder-editor">
                        <h3 *ngIf="(showFolderEditor || showFolderPicker) && !loading.status">{{ !showFolderEditor && showFolderPicker ? 'Move to' : (folderEditing ? 'Edit' : 'Add') }} Folder</h3>
                        <div class="name-editor-container" *ngIf="showFolderEditor && !loading.status">
                            Folder Name:<input type="text" placeholder="Enter new folder name" [formControl]="newFolderName">
                            <div *ngIf="newFolderName.invalid && (newFolderName.dirty || newFolderName.touched)"
                                 class="validation-message">
                                <div *ngIf="newFolderName.errors.required">Name is required</div>
                                <div *ngIf="newFolderName.errors.nameInUse">Name already exist</div>
                            </div>
                        </div>
                        <div class="folder-picker-container" *ngIf="(showFolderEditor || showFolderPicker) && !loading.status">
                            <label>
                                Parent Folder:
                                <select [(ngModel)]="parentFolderId">
                                    <option *ngFor="let option of parentFolders" [ngValue]="option.id">
                                        {{ option.name }}
                                    </option>
                                </select>
                            </label>
                        </div>
                        <div class="confirm-create-folder-container" *ngIf="showFolderEditor && !loading.status">
                            <button class="btn create-folder" (click)="newFolder()" [disabled]="newFolderName.invalid">Save</button>
                            <button class="btn btn-clear" (click)="createNewFolder = false; showFolderEditor = false;">Cancel</button>
                        </div>
                        <div class="confirm-change-folder-container" *ngIf="showFolderPicker && !loading.status">
                            <button class="btn change-folder" (click)="changeFolder()">Save</button>
                            <button class="btn btn-clear" (click)="showFolderPicker = false; showFolderEditor = false;">Cancel</button>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
    <div *ngIf="!loggedIn">
        You must be logged in to view this content. <a (click)="logIn($event)" style="cursor: pointer;">Click here</a> to log in or create an
        account
    </div>
</div>
